import { render, staticRenderFns } from "./investment_fund.vue?vue&type=template&id=35feca25&"
import script from "./investment_fund.vue?vue&type=script&lang=js&"
export * from "./investment_fund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports